<angular-multiselect
[data]="itemList"
[(ngModel)]="selectedItems"
[settings]="settings"
(onSelect)="onItemSelect($event)"
(onDeSelect)="OnItemDeSelect($event)"
(onSelectAll)="onSelectAll($event)"
(onDeSelectAll)="onDeSelectAll($event)"
(onAddFilterNewItem)="onAddItem($event)"
>
</angular-multiselect>
<br>
<div class="alert alert-warning" role="alert">
  <b>How this example works !! </b>
  <br />
  When you try to filter the list items, if no search results are
  available, you would see an 'Add' button. On clicking the add button, it
  would emit the text that you enter in the input field to your controlle
  in the callback method, as show in the below code. You can add this item
  to the data list. If you wish, that this item be selected, add it to
  selected items list.
</div>